const menuSectionEnum = Object.freeze({
    SUPPORT: 1,
    LEGAL: 2
});
export default menuSectionEnum;
